jQuery(document).ready(function($) {
  // Show the first tab on page load
  $('.tabcontent').hide();
  $('.tabcontent#tab-0').show();
  $('.tabs .tablink:first').addClass('active');

  // Handle tab click event
  $('.tabs .tablink').click(function() {
    var tabId = $(this).attr('data-tab');
    $('.tabcontent').hide();
    $('.tabcontent#' + tabId).show();
    $('.tabs .tablink').removeClass('active');
    $(this).addClass('active');
  });


});


// news tabs
jQuery('#tabs-nav li:first-child').addClass('active');
jQuery('.tab-content').hide();
jQuery('.tab-content:first').show();

// Click function
jQuery('#tabs-nav li').click(function(){
  jQuery('#tabs-nav li').removeClass('active');
  jQuery(this).addClass('active');
  jQuery('.tab-content').hide();
  
  var activeTab = jQuery(this).find('a').attr('href');
  jQuery(activeTab).fadeIn();
  return false;
});

 

jQuery(document).ready(function() {
  var $paragraph = jQuery('.single-news-title');
  var lineHeight = parseInt($paragraph.css('line-height'));
  var actualHeight = $paragraph.height();

  if (actualHeight > lineHeight) {
    jQuery('.posfixed').addClass('two-lines');
  }
});